import * as React from 'react'

import MapViewLocationIcon from '~/client/src/shared/enums/SitemapAttributeIcon'
import {
  MARKER_SPEC,
  PICTOGRAM_MARKER_RADIUS,
} from '~/client/src/shared/map/markerGeometry'

import { getMarkerGlyph, isStickerIcon } from '../utils/markerSpec'
interface IMarkerIconProps {
  iconName: MapViewLocationIcon
  color: string
  isHighlighted?: boolean
  onClick?: (e: React.MouseEvent) => void
  onDoubleClick?: (e: React.MouseEvent) => void
}

export default function DomMarkerCircle({
  iconName,
  color,
  isHighlighted,
  onClick,
  onDoubleClick,
}: IMarkerIconProps) {
  // The pending-placement preview hands its item's iconName straight through, so a Line or Text
  // sticker reaches here — and a sticker has no marker to draw. Unknown NAMES still take the pin
  // fallback; only the icon-less kinds bail.
  if (isStickerIcon(iconName)) {
    return null
  }

  const { Icon, isPictogram, viewBox } = getMarkerGlyph(iconName)

  // The same marker the GL rasterizer draws: the art fills the box, and highlight rings it
  // from outside.
  if (isPictogram) {
    return (
      <div
        className="tw:flex"
        style={{
          borderRadius: PICTOGRAM_MARKER_RADIUS,
          boxShadow: isHighlighted
            ? `0 0 0 ${MARKER_SPEC.highlightedBorderWidth}px ${MARKER_SPEC.borderColor}`
            : undefined,
        }}
        onClick={onClick}
        onDoubleClick={onDoubleClick}
      >
        <Icon size={MARKER_SPEC.outerSize} viewBox={viewBox} />
      </div>
    )
  }

  const borderWidth = isHighlighted
    ? MARKER_SPEC.highlightedBorderWidth
    : MARKER_SPEC.borderWidth

  return (
    <div
      style={{
        backgroundColor: color,
        width: MARKER_SPEC.outerSize,
        height: MARKER_SPEC.outerSize,
        borderRadius: '50%',
        border: `${borderWidth}px solid ${MARKER_SPEC.borderColor}`,
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
    >
      {/* Colour rides currentColor rather than the color prop: that only sets stroke,
          and the one filled glyph in the set paints with fill. */}
      <Icon
        size={MARKER_SPEC.iconSize}
        style={{ color: MARKER_SPEC.iconColor }}
      />
    </div>
  )
}
